module.exports = __webpack_public_path__ + "img/lms-dashboard-wikidrivebuzz.72ed53c4.png";